import { useContext } from 'react'
import { PathContext } from '@contexts/PathContext'
import { IEnrollment, ILessonsProgresses } from '@dtos/Enrollment'
import { ICourse } from '@dtos/Course'

interface IUsePath {
  enrollment?: IEnrollment | null
  enrollmentIsLoading: boolean
  coursesInPath: ICourse[]
  lessonsProgresses: ILessonsProgresses[]
  onLoadMore: () => void
}

export const usePath = (): IUsePath => {
  const { enrollment, enrollmentIsLoading, onLoadMore } =
    useContext(PathContext)

  return {
    enrollment,
    enrollmentIsLoading,
    coursesInPath: enrollment?.schoolProduct.path?.courses || [],
    lessonsProgresses: enrollment?.lessonsProgresses || [],
    onLoadMore: onLoadMore || (() => {}),
  }
}
